import { render, staticRenderFns } from "./user-terms-without-code.vue?vue&type=template&id=25b83d6a&scoped=true&"
import script from "./user-terms-without-code.vue?vue&type=script&lang=js&"
export * from "./user-terms-without-code.vue?vue&type=script&lang=js&"
import style0 from "./user-terms-without-code.vue?vue&type=style&index=0&id=25b83d6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b83d6a",
  null
  
)

export default component.exports